<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content>
			<template #content>
				<div class="columns column6">
					<h1>{{ page.title || page.header }}</h1>
					<p v-if="page.bookingID">
						<book-button class="button button-cta" :roomid="page.bookingID" aria-label="Reserve now">
							<span>{{ $t('bookThisRoom') }}</span>
						</book-button>
					</p>
				</div>
				<div class="columns column6">
					<div v-parse-links v-html="page.content" />
				</div>
			</template>
		</main-content>

		<section class="main-content room-info">
			<div class="row background-light">
				<div class="columns column12 align-center">
					<h2>{{ $t('aboutThisRoom') }}</h2>
				</div>
				<div class="columns column8">
					<h3>{{ $t('facilities') }}</h3>
					<div class="room-icons">
						<div v-for="facility in page.facilities" :key="facility.ID" class="icon-holder">
							<font-awesome-icon :icon="`fal fa-${facility.icon}`" size="1x" />
							<span>{{ facility.content }}</span>
						</div>
					</div>
				</div>
				<div class="columns column4">
					<div v-parse-links v-html="page.extraContent" />
				</div>
			</div>
		</section>

		<section class="main-content gallery-section">
			<div class="row gallery-flex-row">
				<div v-for="(item, index) in page.images" :key="index" class="columns column4">
					<picture>
						<source v-if="item.imagesWebp" :srcset="item.imagesWebp" type="image/webp" />
						<source :srcset="item.images" />
						<img :src="item.image" :alt="item.imageAlt" loading="lazy" />
					</picture>
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();

await fetchPage();
</script>

<style lang="scss" scoped>
.main-content {
	:deep(ul) {
		padding: 0 0 0 20px;
	}

	:deep(li) {
		width: 50%;
		float: left;
		padding: 0 50px 0 0;
	}
}

.room-icons {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: flex-start;
	margin: 0 0 40px;
}

.icon-holder {
	color: #8c5c51;
	width: 32%;
	margin: 10px 0;
	font-size: 16px;

	i,
	svg {
		margin: 0 5px 0 0;
	}
}

.room-item .room-icons {
	max-width: 600px;
}

.room-info {
	padding: 0;

	.row {
		padding: 50px 30px;

		ul {
			padding-left: 20px;
		}
	}
}

.gallery-section .columns {
	margin: 15px 0;
}

.gallery-section img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.gallery-flex-row {
	display: flex;
	flex-flow: row wrap;
	justify-content: space-between;
	align-items: center;
}

@media (max-width: 920px) {
	.contentblock-image {
		width: 100%;
		position: relative;
		inset: auto;
	}

	.contentblock {
		display: flex;
		flex-flow: wrap column-reverse;
	}

	.contentblock-content {
		margin: 0 auto 50px;
		padding: 50px 30px;
	}

	.room-info {
		.column12 {
			text-align: left;
		}

		.column4 {
			width: 100%;
		}
	}
}

@media (max-width: 680px) {
	.icon-holder {
		width: 99%;
	}
}
</style>
